<div class="etl-scheduled-jobs-editor-container">
    <div class="header-container">
        <label>{{ title }}</label>
        <smart-icon name="close" (click)="onSlideSheetClose()" class="light"></smart-icon>
    </div>
    <div class="input-container">
        <div class="tam-form-field" [ngClass]="{'has-error':name.invalid}">
            <label class="required">Schedule Name</label>
            <input [(ngModel)]="scheduledJob.name" class="tam-input tam-textbox" type="text" value="scheduledJob.name"
                [formControl]="name">
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['maxlength']">
                {{'general.name_exceed_maximum' | stringLiterals: '128'}}
            </div>
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['nameDuplicated']">
                {{'general.name_already_exist' | stringLiterals}}
            </div>
        </div>
        <div class="tam-form-field">
            <label>ETL Task Name</label>
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" style="width: 50%" [data]="taskNameItems"
                [(ngModel)]="selectedTaskName">
            </kendo-dropdownlist>
        </div>
        <div class="tam-form-field">
            <label>Task Schedule</label>
            <div class="schedule-time">
                Hour <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" style="width: 60px"
                    [data]="hourItems" [(ngModel)]="selectedHour">
                </kendo-dropdownlist>
                Min <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" style="width: 60px" [data]="minItems"
                    [(ngModel)]="selectedMin">
                </kendo-dropdownlist>
            </div>
        </div>
        <div class="tam-form-field">
            <label>Freq</label>
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" style="width: 50%" [data]="freqItems"
                [(ngModel)]="selectedFreq">
            </kendo-dropdownlist>
        </div>
    </div>
    <div class="button-container">
        <button tam-button [tamType]="'primary'" [tamSize]="'normal'" class="button" (click)="onSubmitClick()">
            {{'general.submit' | stringLiterals}}
        </button>
        <button tam-button [tamType]="'tertiary'" [tamSize]="'normal'" class="button" (click)="onSlideSheetClose()">
            {{'general.cancel' | stringLiterals}}
        </button>
    </div>
</div>